module.exports = __webpack_public_path__ + "img/img_026@2x.d287d8f9.png";